"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const amexcvv = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-amexcvv` : '') + (description ? ` desc-amexcvv` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-amexcvv"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-amexcvv"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M37 0.119995H3C1.89543 0.119995 1 1.01543 1 2.12V21.87C1 22.9746 1.89543 23.87 3 23.87H37C38.1046 23.87 39 22.9746 39 21.87V2.12C39 1.01543 38.1046 0.119995 37 0.119995Z",
    fill: "#00ADEF"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M37 0.119995H3C1.89543 0.119995 1 1.01543 1 2.12V21.87C1 22.9746 1.89543 23.87 3 23.87H37C38.1046 23.87 39 22.9746 39 21.87V2.12C39 1.01543 38.1046 0.119995 37 0.119995Z",
    fill: "#0071CE"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.66 4.5H19L17.5 7.69L16 4.5H14V8.72L12.08 4.5H10.18L8 9.5H9.49L9.94 8.39H12.28L12.75 9.5H15.25V5.9L16.92 9.5H18.13L19.66 6.2V9.5H21V4.5H19.7H19.66ZM10.41 7.25L11.09 5.59L11.8 7.25H10.41Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M32 4.5H30.24L28.82 6L27.43 4.5H21.92V9.5H27.32L28.79 7.93L30.23 9.5H32L29.69 7L32 4.5ZM26 9V8.35H23.2V7.56H26V6.43H23.2V5.64H26V4.88L27.93 7L26 9Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M25.94 17.94H34.25V15.57H25.94V17.94Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M30 20.5C34.1421 20.5 37.5 18.933 37.5 17C37.5 15.067 34.1421 13.5 30 13.5C25.8579 13.5 22.5 15.067 22.5 17C22.5 18.933 25.8579 20.5 30 20.5Z",
    stroke: "#FF0000",
    fill: "white"
  }));
};
var _default = exports.default = amexcvv;